"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangePermissionStartElementDestination = void 0;
var tslib_1 = require("tslib");
var list_1 = require("@devexpress/utils/lib/utils/list");
var range_permission_element_destination_1 = require("./range-permission-element-destination");
var RangePermissionStartElementDestination = (function (_super) {
    tslib_1.__extends(RangePermissionStartElementDestination, _super);
    function RangePermissionStartElementDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RangePermissionStartElementDestination.prototype.assignRangePermissionProperties = function (range, reader) {
        range.start = this.data.subDocumentInfo.positionImporter.currPosition;
        range.columnFirst = this.data.readerHelper.getWpSTIntegerValue(reader, 'colFirst', -1);
        range.columnLast = this.data.readerHelper.getWpSTIntegerValue(reader, 'colLast', -1);
        if (this.data.subDocumentInfo.tableImporter.isInsideTable) {
            range.table = list_1.ListUtils.last(this.data.subDocument.tables);
            range.firstRowIndex = this.getLastRowIndexFromTable(range.table);
        }
    };
    return RangePermissionStartElementDestination;
}(range_permission_element_destination_1.RangePermissionElementDestination));
exports.RangePermissionStartElementDestination = RangePermissionStartElementDestination;
